import CameraNew from './CameraNew'

export default CameraNew;